// extracted by mini-css-extract-plugin
export default {"BoxTitle":"BoxTitle_BoxTitle__LD5VU","title":"BoxTitle_title__X6B2g"};